import { render, staticRenderFns } from "./SitePrivacy.vue?vue&type=template&id=20a3e22d&"
import script from "./SitePrivacy.vue?vue&type=script&lang=js&"
export * from "./SitePrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports